import { getAccessToken } from 'api/authTokens';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL || '';

// Downloads a file from a signed-in endpoint. A plain link cannot carry the Bearer token, so fetch it and save the blob.
export async function downloadAuthed(url) {
  const target = /^https?:\/\//i.test(url) ? url : `${API_BASE_URL}${url}`;
  const token = getAccessToken();
  const res = await fetch(target, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(res.status === 404 ? 'The file is no longer available.' : `Download failed (${res.status}).`);
  const match = (res.headers.get('content-disposition') || '').match(/filename="?([^";]+)"?/);
  const href = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = href;
  a.download = match ? match[1] : 'download';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
